// extracted by mini-css-extract-plugin
export default {"tab__remove-button":"styles_tab__remove-button__tjTeL"};